import React, {useState} from "react";
import {useSelector} from "react-redux";
import {DragDropContext} from 'react-beautiful-dnd';
import {Box, Divider, Menu, MenuItem} from "@material-ui/core";
import useStyles from '../Elements/Styles';
import InfoBoxes from "../Elements/InfoBoxes";
import Dropzone from "../Elements/Dropzone";
import ViewItems from "./ViewItems";
import {uploadFile} from "redux/actions/fileManager";

const contextMenuInitial = {
    mouseX: null,
    mouseY: null,
    selected: null
};

export default function ContainerBar({messages, operations, isloading, uploadBox, buttons}) {
    const classes = useStyles();

    const {selectedFolder} = useSelector(state => state.fileManager);

    const [itemContext, itemContexSet] = useState(contextMenuInitial);
    const [contentContex, contentContexSet] = useState(contextMenuInitial);

    const handleAddSelected = value => {
        operations.handleAddSelected(value);
    };

    const handleItemContextClick = event => {
        event.stopPropagation();
        event.preventDefault();
        contentContexSet(contextMenuInitial);
        itemContexSet({
            mouseX: event.clientX - 2,
            mouseY: event.clientY - 4,
        });
    };

    const handleContentContextClick = event => {
        event.stopPropagation();
        event.preventDefault();
        itemContexSet(contextMenuInitial);
        contentContexSet({
            mouseX: event.clientX - 2,
            mouseY: event.clientY - 4,
        });
    };

    const handleContextClose = () => {
        itemContexSet(contextMenuInitial);
        contentContexSet(contextMenuInitial);
    };

    return (
        <Box className={classes.root}>
            <div className={classes.messagesBox}>
                {messages.map((alert, index) => <InfoBoxes key={index} alert={alert}/>)}
            </div>

            {isloading &&
            <Box className={classes.loadingBlock}>
                <div className="opaOverlaw"></div>
            </Box>
            }

            {uploadBox &&
            <Dropzone currentFolder={selectedFolder} handleReload={operations.handleReload} uploadFile={uploadFile}
                      handleCancel={operations.handleUpload}/>
            }
            <div
                className={classes.container}
                onContextMenu={handleContentContextClick}
            >
                <DragDropContext onDragEnd={operations.handleDragEnd}>

                    <ViewItems
                        onContextMenuClick={handleItemContextClick}
                        doubleClick={operations.handleSetMainFolder}
                        addSelect={handleAddSelected}
                    />

                </DragDropContext>
            </div>

            <Menu
                keepMounted
                open={itemContext.mouseY !== null}
                className={classes.menu}
                onContextMenu={handleContextClose}
                onClose={handleContextClose}
                anchorReference="anchorPosition"
                anchorPosition={
                    itemContext.mouseY !== null && itemContext.mouseX !== null
                        ? {top: itemContext.mouseY, left: itemContext.mouseX}
                        : undefined
                }
            >
                {buttons.file.map((buttonGroup, index) =>
                    [
                        buttonGroup.map((button, index) =>
                            <MenuItem key={index} disabled={button.disable} className={classes.menuItem}
                                      onClick={() => {button.onClick(); handleContextClose()}}>
                                <span className={`${button.icon}`}></span>{button.title}
                            </MenuItem>
                        ),
                        <Divider/>
                    ]
                )}
            </Menu>

            <Menu
                keepMounted
                open={contentContex.mouseY !== null}
                className={classes.menu}
                onContextMenu={handleContextClose}
                onClose={handleContextClose}
                anchorReference="anchorPosition"
                anchorPosition={
                    contentContex.mouseY !== null && contentContex.mouseX !== null
                        ? {top: contentContex.mouseY, left: contentContex.mouseX}
                        : undefined
                }
            >
                {buttons.container.map((buttonGroup, index) =>
                    [
                        buttonGroup.map((button, index) =>
                            <MenuItem key={index} disabled={button.disable} className={classes.menuItem}
                                      onClick={button.onClick}>
                                <span className={`${button.icon}`}></span>{button.title}
                            </MenuItem>
                        ),
                        <Divider/>
                    ]
                )}
            </Menu>


        </Box>
    )
}